// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"b245551c","374":"0415b26a","403":"2bdc15da","484":"14cb0921","551":"c2ddb01f","869":"307896e8","870":"a02cfa12","974":"5be244d3"}[chunkId] + ".chunk.js";
};